import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SignupErrorMessage.module.css";
import PropTypes from "prop-types";

const SignupErrorMessage = ({ airline, position }) => {
  const navigate = useNavigate();

  return (
    <>
      {airline === "UPS" && position == "LOGIN" ? (
        <div className="container text-center mt-5 mb-5">
          <h2>Your signup has not been completed.</h2>
          <p className="mt-3">
            Please log in to your account in order to purchase a subscription,
            or contact support for help.
          </p>
        </div>
      ) : (
        <div className="container text-center mt-5 mb-5">
          <h2>The signup was unsuccessful.</h2>
          <p className="mt-3">
            A pilot with your Employee Number or email address is already in our
            system.
          </p>
          <p>
            Please log in to your account in order to purchase a subscription,
            or contact support for help.
          </p>
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/login")}
          >
            Log In
          </button>
        </div>
      )}
    </>
  );
};

SignupErrorMessage.propTypes = {
  airline: PropTypes.string,
  position: PropTypes.string,
};

export default SignupErrorMessage;
